import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { AuthGuard } from './guards/auth.guard';
import { NotLoggedInGuard } from './guards/not-logged-in.guard';
import { ResetGuard } from './guards/reset.guard';
import { IsWebAdminGuard } from './guards/is-web-admin.guard';

const routes: Routes = [
    {
        path: '', loadChildren: './pages/layout/layout.module#LayoutModule',
        canActivate: [AuthGuard, IsWebAdminGuard]
    },
    { 
        path: 'login', component: LoginComponent,
        canActivate: [NotLoggedInGuard]
    },
    { 
        path: 'forgotpassword', component: ForgotPasswordComponent,
        canActivate: [NotLoggedInGuard] 
    },
    { 
        path: 'resetpassword', component: ResetPasswordComponent,
        // canActivate: [ResetGuard] 
    },
    { 
        path: '**', redirectTo: '' 
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
